// Panier : retirer d'un coup toutes les enquêtes d'un pack (snippets/cart-pack.liquid)
if (!window.cartPackInit) {
  window.cartPackInit = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-pack-remove]');
    if (!button) return;
    event.preventDefault();

    const updates = {};
    button.dataset.cartPackRemove.split(',').filter(Boolean).forEach((key) => { updates[key] = 0; });
    button.setAttribute('aria-busy', 'true');

    fetch(`${theme.routes.cartPage}/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates })
    })
      .then((response) => response.json())
      .then((cart) => {
        if (button.closest('#CartPageForm')) {
          window.location.reload();
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
      })
      .catch((error) => console.error('[cart-pack]', error))
      .finally(() => button.removeAttribute('aria-busy'));
  });
}
